import React from "react";
import { displayDate, money, orderGroup, paymentText, progressStep, statusText } from "./historyHelpers";

const Progress = ({ order }) => {
  const current = progressStep(order);
  const stages = [
    ["Order Placed", order.pending || order.creation_date],
    ["Picked Up", order.picked_up],
    ["In Laundry", order.processing || order.arrived],
    ["Out for Delivery", order.out_for_delivery],
    ["Delivered", order.delivered],
  ];
  return <div className="ohr-order-progress"><span className="ohr-order-line" />{stages.map(([label, date], index) => <div className={index < current ? "active" : ""} key={label}><b>{index < current ? <i className="fa-solid fa-check" /> : index + 1}</b><strong>{label}</strong>{date && <small>{displayDate(date, "dd-MM-yyyy")}<br />{displayDate(date, "p")}</small>}</div>)}</div>;
};

export const HistoryOrderItem = ({ order, expanded, onToggle, onView }) => {
  const group = orderGroup(order);
  const terminalDate = group === "completed" ? order.delivered : group === "cancelled" ? order.cancelled : null;
  return (
    <article className="ohr-card ohr-order">
      <button className="ohr-order-head" type="button" onClick={onToggle}>
        <span className="ohr-shirt"><i className="fa-solid fa-shirt" /></span>
        <span className="ohr-order-info">
          <span><strong>#{order.id}</strong><em className={group}>{statusText(order)}</em></span>
          <small>
            <span><i className="fa-solid fa-cube" />{Number(order?.laundry_delivery_type?.id) === 3 ? "Come & Collect" : order?.laundry_delivery_type?.title || "Pickup & Delivery"}</span>
            <span><i className="fa-regular fa-calendar" />{displayDate(order.pickup_date, "eee, dd MMM yyyy", true)}</span>
            <span><i className="fa-regular fa-clock" />{order.pickup_time || "—"}</span>
            <span><i className="fa-solid fa-credit-card" />{paymentText(order.payment_method)}</span>
          </small>
        </span>
        <strong className={`ohr-amount ${group}`}>Rs. {money(order.order_amount)}</strong>
        <i className={`fa-solid fa-chevron-${expanded ? "up" : "down"}`} />
      </button>
      {expanded && <div className="ohr-expanded">{group === "in_progress" ? <><Progress order={order} /><p className="ohr-message"><i className="fa-regular fa-circle-info" />Your order is progressing with care. We'll notify you when the status changes.</p></> : <p className={`ohr-terminal ${group}`}><i className={`fa-regular fa-circle-${group === "completed" ? "check" : "xmark"}`} />{group === "completed" ? "Delivered" : "Cancelled"}{terminalDate ? ` on ${displayDate(terminalDate, "eee, dd MMM yyyy 'at' p")}` : ""}</p>}<div className="ohr-order-actions"><button type="button" onClick={onView}><i className="fa-solid fa-list" />View Details</button><a href="mailto:support@jabchaho.com"><i className="fa-solid fa-headphones" />Contact Support</a></div></div>}
    </article>
  );
};
